/* eslint-disable */
import { toast } from 'react-toastify'

export function NotificaSuccess(msg) {
  toast.success(msg, {
    position: 'top-center',
    autoClose: 2000,
  })
}
